import React from "react";
import {getModelFactory} from "../../ts/model-factory/ModelFactory";
import StateViewController from "../vc/StateViewController";
import {IRouteProps} from "../../ts/manager/view/ViewInterface";
import {assert} from "../../ts/common/Assert";
import ContentBlocksStructure from "../partial/structure/ContentBlocksStructure";

const HomePage = (props:IRouteProps) =>
{
    const pageChoice = getModelFactory().browseRoute.getDefaultModel().choices.homepage?.postDataChoice ?? null

    const viewState = StateViewController({
        routeProps: props,
        assert: pageChoice
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    assert(pageChoice);


    return <>
        <ContentBlocksStructure blocks={pageChoice.getContentBlocks()}/>
    </>
};

export default HomePage;
